<div class="relative flex flex-col items-center gap-4 px-36 pb-20 pt-14 md:px-6 md:py-8">
    <app-diagnostic-header [subtitle]="subtitle()"></app-diagnostic-header>
    <div class="mt-8 flex w-full max-w-[800px] justify-between md:flex-col">
        <div class="w-2/3 md:mb-8 md:w-full">
            <div class="malou-text-18--bold md:malou-text-16--bold mb-4 text-malou-text">
                {{ 'maloupe.diagnostic_search.event.search_bar.title' | translate }}*
            </div>
            <app-input-google-maps-autocomplete
                [placeholder]="'maloupe.diagnostic_search.common.search_bar.placeholder' | translate"
                [errorMessage]="autocompleteErrorMessage()"
                [getPlaceDiagnosticRateLimitPerDayExceeded]="getPlaceDiagnosticRateLimitPerDayExceeded()"
                (locationSelected)="onLocationSelected($event)"
                (inputGoogleMapsAutocompleteChange)="onInputChanged($event)"></app-input-google-maps-autocomplete>
        </div>
        <ng-container [ngTemplateOutlet]="locationSearchForm"></ng-container>
    </div>
    <ng-container [ngTemplateOutlet]="instagramSearchForm"></ng-container>
    <ng-container [ngTemplateOutlet]="userInformationForm"></ng-container>
    <div class="flex justify-center md:mb-10 md:w-full">
        <button
            class="malou-btn-flat md:w-full"
            mat-flat-button
            [disabled]="
                isLoading() ||
                !hasCategory() ||
                getPlaceDiagnosticRateLimitPerDayExceeded() ||
                (this.instagramControl.value !== null && this.instagramControl.value !== '' && !this.instagramPageValidated()) ||
                informationFormGroup.invalid
            "
            (click)="computeMyDiagnostic()">
            {{ 'maloupe.diagnostic_search.common.submit_button' | translate }}
        </button>
    </div>
    <img class="absolute bottom-0 right-[11%] w-44 md:w-16" alt="Goggles" [src]="Illustration.GOGGLES | illustrationPathResolver" />
</div>

<ng-template #locationSearchForm>
    <form>
        <div class="malou-text-18--bold md:malou-text-16--bold mb-4 text-malou-text" [class.opacity-50]="categoryControl.disabled">
            {{ 'maloupe.diagnostic_search.event.category.title' | translate }}*
        </div>
        <form>
            <mat-form-field class="malou-filled-form-field w-full">
                <input
                    matInput
                    aria-label="Catégorie"
                    [placeholder]="'maloupe.diagnostic_search.event.category.title' | translate"
                    [class.italic]="hasCategory()"
                    [class.malou-text-12--medium]="hasCategory()"
                    [matAutocomplete]="auto"
                    [formControl]="categoryControl" />
                <div class="flex items-center pr-5" matSuffix>
                    <mat-icon class="!h-4 !w-4 text-malou-primary" [svgIcon]="SvgIcon.CHEVRON_DOWN"></mat-icon>
                </div>
                <mat-autocomplete #auto="matAutocomplete">
                    @for (category of filteredCategories(); track category) {
                        <mat-option
                            [value]="category.getCategoryNameForLang(locale)"
                            (onSelectionChange)="onLocationCategoryChanged(category)">
                            <span>{{ category.getCategoryNameForLang(locale) }}</span>
                        </mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>
        </form>
    </form>
</ng-template>

<ng-template #instagramSearchForm>
    <div class="w-full max-w-[800px]">
        <form>
            <div class="malou-text-18--bold mb-4 gap-2 text-malou-text md:flex md:flex-col">
                <span>{{ 'maloupe.diagnostic_search.common.instagram.title' | translate }}</span>
            </div>
            <app-input-instagram-search
                [diagnostic]="diagnostic()"
                [instagramControl]="instagramControl"
                [instagramPage]="instagramPage()"
                [instagramPageValidated]="instagramPageValidated()"
                (instagramPageSelection)="onSelectedInstagramPage()"
                (instagramPageChange)="onInstagramPageChanged($event)"></app-input-instagram-search>
        </form>
    </div>
</ng-template>

<ng-template #userInformationForm>
    <div class="w-full max-w-[800px]">
        <form class="flex flex-col justify-between" [formGroup]="informationFormGroup">
            <div class="flex w-full justify-between md:flex-col md:gap-2">
                <div class="w-[48%] md:w-full">
                    <div class="malou-text-18--bold mb-4 gap-4 text-malou-text">
                        {{ 'maloupe.diagnostic_information_form.form.last_name' | translate }}*
                    </div>
                    <input
                        class="malou-text-12--medium malou-input border-malou-border-primary"
                        type="text"
                        formControlName="lastName"
                        [placeholder]="'maloupe.diagnostic_information_form.form.last_name' | translate"
                        [class.italic]="!lastName" />
                </div>
                <div class="w-[48%] md:w-full">
                    <div class="malou-text-18--bold mb-4 gap-4 text-malou-text">
                        {{ 'maloupe.diagnostic_information_form.form.first_name' | translate }}*
                    </div>
                    <input
                        class="malou-text-12--medium malou-input border-malou-border-primary"
                        type="text"
                        formControlName="firstName"
                        [placeholder]="'maloupe.diagnostic_information_form.form.first_name' | translate"
                        [class.italic]="!firstName" />
                </div>
            </div>

            <div class="flex w-full justify-between md:flex-col md:gap-2">
                <div class="w-[48%] md:w-full">
                    <div class="malou-text-18--bold mb-4 gap-2 text-malou-text">
                        {{ 'maloupe.diagnostic_search.event.user_info.phone_number' | translate }}*
                    </div>
                    <input
                        class="malou-text-12--medium malou-input"
                        type="tel"
                        formControlName="phoneNumber"
                        [placeholder]="phonePlaceHolder()"
                        [class.!mb-0]="phoneNumberControl.hasError('minlength')"
                        [class.!border-malou-pink]="phoneNumberControl.hasError('minlength')"
                        [class.!border-[1px]]="phoneNumberControl.hasError('minlength')"
                        [class.italic]="!phoneNumber"
                        (keypress)="preventInvalidPhoneNumberInput($event)" />

                    @if (phoneNumberControl.hasError('minlength')) {
                        <p class="malou-text-10 my-1.5 ml-6 font-medium text-malou-pink">
                            {{ 'maloupe.diagnostic_information_form.form.phone_error' | translate }}
                        </p>
                    }
                </div>
                <div class="w-[48%] md:w-full">
                    <div class="malou-text-18--bold mb-4 gap-2 text-malou-text">
                        {{ 'maloupe.diagnostic_information_form.form.email' | translate }}*
                    </div>
                    <input
                        class="malou-text-12--medium malou-input"
                        type="text"
                        formControlName="email"
                        [placeholder]="'Email@gmail.com'"
                        [class.!border-malou-pink]="emailControl.hasError('email')"
                        [class.!border-[1px]]="emailControl.hasError('email')"
                        [class.!mb-0]="emailControl.hasError('email')"
                        [class.italic]="!email" />
                    @if (emailControl.hasError('email')) {
                        <p class="malou-text-10 my-1.5 ml-6 font-medium text-malou-pink">
                            {{ 'maloupe.diagnostic_information_form.form.email_error' | translate }}
                        </p>
                    }
                </div>
            </div>
            <div class="w-full">
                <div class="malou-text-18--bold mb-4 gap-2 text-malou-text">
                    {{ 'maloupe.diagnostic_information_form.form.location_count' | translate }}*
                </div>
                <input
                    class="malou-text-12--medium malou-input"
                    type="tel"
                    formControlName="locationCount"
                    [placeholder]="3"
                    [class.!mb-0]="locationCountControl.hasError('min')"
                    [class.!border-malou-pink]="locationCountControl.hasError('min')"
                    [class.!border-[1px]]="locationCountControl.hasError('min')"
                    [class.italic]="!locationCount"
                    (keypress)="preventNonNumericalValue($event)" />

                @if (locationCountControl.hasError('min')) {
                    <p class="malou-text-10 my-1.5 ml-6 font-medium text-malou-pink">
                        {{ 'maloupe.diagnostic_information_form.form.location_count_error' | translate }}
                    </p>
                }
            </div>
            <mat-checkbox formControlName="termsAndConditions">
                <span class="!malou-text-14--bold text-malou-text">
                    {{ 'maloupe.diagnostic_information_form.form.privacy_policy_1' | translate }}
                    <span class="underline" (click)="redirectToPrivacyPolicy()">
                        {{ 'maloupe.diagnostic_information_form.form.privacy_policy_2' | translate }}
                    </span>
                </span>
            </mat-checkbox>

            @if (isFstec()) {
                <mat-checkbox formControlName="weekendParisGeneralConditions">
                    <span class="!malou-text-14--bold text-malou-text">
                        {{ 'maloupe.diagnostic_information_form.form.event.fstec_2025.weekend_paris_1' | translate }}
                        <span class="underline" (click)="redirectToWeekendInParisGeneralConditions()">
                            {{ 'maloupe.diagnostic_information_form.form.event.fstec_2025.weekend_paris_2' | translate }}
                        </span>
                        {{ 'maloupe.diagnostic_information_form.form.event.fstec_2025.weekend_paris_3' | translate }}
                    </span>
                </mat-checkbox>
            }
        </form>
    </div>
</ng-template>
